/**
 * RefLinks — the records a field names (`cis_field(ref=...)`), each a link to its page where it has one, comma
 * separated. Used by record facts, child tables and list cells. A click or Enter on a link opens that record only:
 * on a list the row around it also opens its own record, and must not (stopPropagation).
 */
import { Link } from "react-router";
import type { PresentedRef } from "@shared-core/domain/object-ui/refs";

export function RefLinks({ refs }: { refs: readonly PresentedRef[] }) {
  return (
    <>
      {refs.map((ref, i) => (
        <span key={`${ref.label}-${i}`}>
          {i > 0 && ", "}
          {ref.href ? (
            <Link
              to={ref.href}
              className="text-primary underline-offset-2 hover:underline"
              onClick={(e) => e.stopPropagation()}
            >
              {ref.label}
            </Link>
          ) : (
            ref.label
          )}
        </span>
      ))}
    </>
  );
}
